<script src="input-autocomplete.component.ts"></script>
@if (!showViewMode) {
  <div [formGroup]="form" [ngClass]="{'inverted': invertedColor}"
    class="component-wrapper">
    @if (hasLabel) {
      <div class="label-wrapper">
        @if (label) {
          <label
            [for]="HTML_ID"
            [ngClass]="{'small': isSmallLabel}">
            <span [attr.data-cy]="labelCypressTag">{{label}}</span>
          </label>
        }
        @if (hasWarningStar) {
          <app-warning-star
            [attr.data-cy]="warningStarCypressTag"
          [type]="warningLevel"></app-warning-star>
        }
        <div class="label-information">
          <ng-container *ngTemplateOutlet="labelInformation"></ng-container>
        </div>
      </div>
    }
    <div [attr.data-cy]="inputWrapperCypressTag"
      [ngClass]="{'invalid': !isValid, 'focus': isFocused, 'disabled': isDisabled, 'alternate-background': alternateBackground}"
      class="input-wrapper">
      <app-tooltip [disable]="inputHasEllipsis"
        [dynamic]="false"
        [message]="inputFormatter(tooltipText)">
        <input #nativeHtmlInput
          (blur)="inputBlur.emit($event)"
          (click)="inputClick.emit($event)"
          (focus)="inputFocus.emit($event)"
          (keydown)="inputKeyDown.emit($event)"
          (mouseenter)="toggleTooltip($event)"
          (selectItem)="customSelectItem($event)"
          [attr.data-cy]="textInputCypressTag"
          [formControlName]="FORM_CONTROL_NAME"
          [id]="HTML_ID"
          [inputFormatter]="inputFormatter"
          [ngStyle]="inputHeight"
          [ngbTypeahead]="search"
          [placeholder]="placeholder"
          [resultTemplate]="tooltipResultTemplate"
          class="text-ellipsis input"
          type="text">
      </app-tooltip>
      <div class="icon-wrapper">
        @if (hasDeleteButton) {
          <button (click)="deleteInputValue()"
            [attr.data-cy]="deleteButtonCypressTag"
            class="input-button">
            <span [class]="deleteButtonIconClass"></span>
          </button>
        }
        <button class="input-button">
          <span [class]="SEARCH_ICON_CLASS"></span>
        </button>
      </div>
    </div>
    @if (showMessages) {
      @for (message of messages | anyKeyValue; track message) {
        @if (message.value.length > 0) {
          <app-warning-inline
            [warningInlineLabelsArray]="message.value"
          [warningType]="message.key"></app-warning-inline>
        }
      }
    }
  </div>
} @else {
  <div [ngClass]="{'inverted': invertedColor}" class="component-view-wrapper">
    <div class="label-wrapper">
      @if (label) {
        <label
          [ngClass]="{'small': isSmallLabel}">
          <span [attr.data-cy]="labelCypressTag">{{label}}</span>
        </label>
      }
      <div class="label-information">
        <ng-container *ngTemplateOutlet="labelInformation"></ng-container>
      </div>
    </div>
    <div [attr.data-cy]="inputWrapperCypressTag" class="input-wrapper view-mode">
      @if (resultFormatter == null) {
        <span
        [attr.data-cy]="inputValueCypressTag">{{initialValue}}</span>
      } @else {
        <span [attr.data-cy]="inputValueCypressTag">{{resultFormatter(initialValue)}}</span>
      }
    </div>
  </div>
}

<ng-template #tooltipResultTemplate let-result="result" let-term="term">

  @if (dropdownValueIsTemplateRef($safeNavigationMigration(result?.template))) {
    <ng-container *ngTemplateOutlet="$safeNavigationMigration(result?.template)"></ng-container>
  } @else {
    @if (showInactiveTemplate(result)) {
      <ng-container
      *ngTemplateOutlet="inactiveTooltipTemplate; context: {result: result, term: term}"></ng-container>
    } @else {
      @if (hasResultTemplate) {
        <ng-container *ngTemplateOutlet="resultTemplate; context: {result: result, term: term}"></ng-container>
      } @else {
        <app-tooltip [message]="resultFormatter(result)">
          <ngb-highlight [result]="resultFormatter(result)" [term]="term"></ngb-highlight>
        </app-tooltip>
      }
    }
  }



  <ng-template #inactiveTooltipTemplate>
    @if (!dropdownDisabled) {
      <app-tooltip [dynamic]="false"
        [message]="tooltipInactiveMessage(resultFormatter(result))"
        [orderedList]="false">
        <ngb-highlight [attr.data-cy]="inactiveOptionDataCy" [result]="resultFormatter(result)" [term]="term"
        class="disabled-option"></ngb-highlight>
      </app-tooltip>
    } @else {
      <ngb-highlight [attr.data-cy]="inactiveOptionDataCy" [result]="resultFormatter(result)" [term]="term"
      class="disabled-option"></ngb-highlight>
    }
  </ng-template>


</ng-template>

